window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

// Format numbers as currency
Number.prototype.format = function (n, x) {
  let re = '(\\d)(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$1,');
};
// Format strings to Title Case
String.prototype.toTitleCase = function () {
  let re = '[-_]'
  let replaced = this.replace(new RegExp(re, 'gm'), ' ')
  let cleaned = ''
  let words = replaced.split(' ')
  if (words.length == 1) {
    let cp = '[A-Z]'
    let matched = this.match(new RegExp(cp, 'gm'))
    let splitted = this.split('')
    for (let j = 0; j < matched.length; j++) {
      const element = matched[j];
      let index = splitted.indexOf(element)
      if (index == 0) {
        continue;
      }
      splitted[index] = ' ' + splitted[index]
    }
    let sjoined = splitted.join()
    let cleaned = sjoined.replaceAll(',', '')
    return cleaned
  }
  for (let i = 0; i < words.length; i++) {
    let element = words[i].toLowerCase();
    let th = element.charAt(0).toUpperCase()

    let joined = th + element.slice(1)
    cleaned = cleaned + joined + ' '
  }
  return cleaned.trim()
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      // console.log('SW1 registered: ', registration);
      // registration.update();
    }).catch(registrationError => {
      console.error('SW1 registration failed: ', registrationError);
    });
  });
}
